var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "py-10px",
    attrs: {
      "width": "80"
    }
  }, [_c('div', {
    staticClass: "d-block font-size-12 font-weight-medium text-center pb-10px"
  }, [_vm._v("최근 본 상품")]), _vm._l(_vm.recentProducts, function (product) {
    return [_c('v-card', {
      key: product._id,
      attrs: {
        "tile": "",
        "elevation": "0",
        "to": "/shop/products/".concat(product._id)
      }
    }, [_c('v-img', {
      staticClass: "my-2 mx-auto",
      attrs: {
        "src": product.thumb,
        "contain": "",
        "width": "72",
        "height": "72"
      }
    })], 1)];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }